import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState, store} from "@/app/store";
import Util from "@/Master/Util";
import {RewardType} from "@/Core/Reward/RewardInfo";

export interface MainState {
    isDBok: boolean,
    isChannelOk: boolean,
    rewardType: RewardType,
    cashAppValidDays:number,
    isKycPending:boolean,
    withdrawalThreshold:number,

    channelQid:string,
    attributionData:any,
}

const initialState: MainState = {
    isDBok: false,
    isChannelOk: false,
    rewardType:RewardType.GC,

    cashAppValidDays:5,
    isKycPending:false,
    withdrawalThreshold:25,
    channelQid:'',
    attributionData:'',
}

export const mainSlice = createSlice({
    name: 'MainState',
    initialState,
    reducers: {
        setMainState: (state, action: PayloadAction<Partial<MainState>>) => {
            if (Util.isLog) {
                console.group('MainState 设置前');
                console.log('MainState 设置前',state,action.payload);
            }

            const newState = {
                ...state,
                ...action.payload,
            };

            // newState.isKycPending = true;
            if (Util.isLog) {
                console.log('MainState 设置后',newState);
                console.groupEnd();
            }

            return newState;
        },
    },
})

export const { setMainState } = mainSlice.actions;

export const selectMainState = (state: RootState) => state.mainState as MainState;

export default mainSlice.reducer;

